import Api from '@/api'


const fetchAll = () => {	
    return Api.get('api/projects')
};

const postForm =  (payload,id) => {  
    
    if(typeof id != "undefined") { 
        
        return Api.put('api/projects/' + id , payload)       
    } else {
        return Api.post('api/projects' , payload)       
    }
    
};

const getById =  (payload) => {        
    return Api.get('api/projects/' + payload)       
};

const deleteById =  (payload) => {        
    return Api.delete('api/projects/'+payload)
    
};

export default {
  fetchAll,
  postForm,
  getById,
  deleteById
};